import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { hidePopup } from 'swag-client-common/redux/popup-manager/popup-manager.actions';
import { isCheckoutOutOfStockAdjustmentPopupShownSelector } from 'swag-client-common/redux/popup-manager/popup-manager.selector';
import { includeHiddenItemsSelector } from '../../../redux/cart/cart.selectors';
import CheckoutOutOfStockAdjustmentPopup from './checkout-out-of-stock-adjustment-popup';
const mapStateToProps = createStructuredSelector({
  isOpen: isCheckoutOutOfStockAdjustmentPopupShownSelector,
  isSomeItemsHidden: includeHiddenItemsSelector
});
const mapDispatchToProps = dispatch => ({
  onClose: goToFn => {
    dispatch(hidePopup());
    goToFn && goToFn();
  }
});
export default connect(mapStateToProps, mapDispatchToProps)(CheckoutOutOfStockAdjustmentPopup);